import React from 'react'

import {
  Container,
  WhiteWrapper,
  SubTitle,
  Information,
  SunIcon,
  HouseLogo,
  ManchaLaranja,
} from './styles'

export default function Servicos() {
  return (
    <Container>
        <WhiteWrapper id="aula-ingles">
          <SubTitle>Aulas de Inglês</SubTitle>
          <Information>
            Aprenda inglês para usar, não apenas para estudar.<br/>
            Nossas aulas são personalizadas de acordo com seus objetivos: viagens, carreira, entrevistas, apresentações, conversação, mudança de país ou desenvolvimento pessoal. Trabalhamos com situações reais, vocabulário aplicado e prática constante de fala.<br/>
            Você desenvolve fluência com segurança e naturalidade, no seu ritmo e com acompanhamento próximo.<br/>
            As aulas podem acontecer online ou presencialmente, inclusive na sua casa, oferecendo conforto, praticidade e um ambiente familiar para potencializar o aprendizado.<br/>
          </Information>
          <SunIcon />
        </WhiteWrapper>
        <WhiteWrapper id="aula-espanhol">
          <SubTitle>Aulas de Espanhol</SubTitle>
          <Information>
            Espanhol para se comunicar com confiança no mundo real.<br/>
            As aulas são adaptadas ao seu nível e às suas metas: negócios, intercâmbio, viagens, certificações ou comunicação profissional. Trabalhamos diferenças culturais, expressões autênticas e contextos reais de uso do idioma.<br/>
            O foco é desenvolver compreensão, fala e escrita de forma equilibrada e funcional.<br/>
            As aulas podem acontecer online ou presencialmente (inclusive na sua casa) oferecendo conforto, praticidade e um ambiente familiar para potencializar o aprendizado.<br/>
          </Information>
          <HouseLogo />
        </WhiteWrapper>
        <WhiteWrapper id="aula-italiano">
          <SubTitle>Aulas de Italiano</SubTitle>
          <Information>
            Para quem quer se reconectar com a herança familiar, viajar pela Itália com mais autonomia ou explorar a cultura italiana de dentro, as aulas partem dos seus objetivos. O conteúdo trabalha vocabulário de uso real, compreensão oral, escrita e prática de comunicação em situações do dia a dia. Trabalhamos com aspectos culturais e bastante prática de expressão oral, além dos conteúdos gramaticais e de vocabulário da língua italiana, além de incluir temas que costumam fazer parte do interesse pelo idioma, como família, origem, gastronomia, arte e modos de vida.<br/>
            Ao longo das aulas, você desenvolve recursos para se comunicar em italiano de forma funcional e compreender melhor os contextos em que o idioma é usado.<br/>
            As aulas podem acontecer online ou presencialmente, inclusive na sua casa, com uma proposta personalizada e adaptada aos seus objetivos.<br/>
          </Information>
        </WhiteWrapper>
        <WhiteWrapper id="aula-frances">
          <SubTitle>Aulas de Francês</SubTitle>
          <Information>
            Seja para viajar, trabalhar, morar na França ou porque você simplesmente gosta da língua, as aulas são adaptadas ao que você quer alcançar. Trabalhamos com situações reais de uso do idioma, vocabulário aplicado e prática constante de conversação, sempre com referência no Quadro Europeu Comum de Referência para Línguas, que guia os níveis de proficiência e prepara o aluno para certificações oficiais. Além do ensino do idioma em si, trabalhado sempre de forma aplicada a situações reais e práticas de comunicação, focamos também na aquisição de conhecimentos relacionados à cultura francófona em sua amplitude.<br/>
            As turmas têm no máximo quatro alunos, o que permite um acompanhamento individualizado e atenção real ao ritmo de cada pessoa. Os pontos fortes e os pontos a desenvolver são analisados com frequência, garantindo uma evolução consistente e natural.<br/>
            As aulas acontecem online ou presencialmente, inclusive na sua casa.<br/>
          </Information>
          <ManchaLaranja />
        </WhiteWrapper>
        <WhiteWrapper id="aula-portugues">
          <SubTitle>Aulas de Português</SubTitle>
          <Information>
            <strong>Para Estrangeiros</strong><br/><br/>
            As nossas aulas estão montadas para que você consiga aprender o português real falado no Brasil, de maneira efetiva e eficaz.<br/>
            Você aprende conosco expressões autênticas do português brasileiro e a interagir nas mais diferentes situações prática da vida real.<br/>
            O nosso objetivo é que você adquira fluência por meio de um método de ensino afetivo e individualizado, pensado para as suas reais necessidades com o português.<br/>
            As nossas aulas podem acontecer online ou presencialmente (tanto no seu local, seja ele em casa ou no trabalho, quanto no nosso espaço físico, localizado no bairro de Moema), oferecendo um ambiente confortável para que o seu aprendizado ocorra da melhor forma para você!<br/>
            <br/>
            <strong>Reforço escolar</strong><br/><br/>
            As nossas aulas de reforço de português são pensadas para os alunos pré-adolescentes e adolescentes que precisam de acompanhamento escolar.<br/>
            O nosso objetivo está em fazer com que o aluno se sinta mais confiante ao realizar as provas escolares e adquira uma melhor capacidade interpretativa de leitura de textos em diferentes gêneros, sempre segundo as exigências da escola regular e em um ambiente acolhedor e afetivo.<br/>
            As aulas podem ser online ou presenciais (inclusive em casa), oferecendo conforto e praticidade para potencializar o aprendizado dos alunos e melhorar seu desempenho em português na escola.<br/>
          </Information>
          <SunIcon />
        </WhiteWrapper>
        <WhiteWrapper id="aula-individuais">
          <SubTitle>Aulas Individuais</SubTitle>
          <Information>
            100% personalizadas. 100% focadas em você.<br/>
            As aulas individuais permitem um plano totalmente adaptado às suas necessidades, com flexibilidade de ritmo, conteúdos e profundidade. Ideal para quem tem objetivos específicos, agenda mais complexa ou deseja acelerar o aprendizado.<br/>
            Aqui, o seu processo é prioridade.<br/>
          </Information>
        </WhiteWrapper>
        <WhiteWrapper id="aula-grupo">
          <SubTitle>Aulas em Grupo (até 4 alunos)</SubTitle>
          <Information>
            Aprender em grupo, sem perder a personalização.
            <br/>
            Turmas reduzidas (máximo de 4 alunos) garantem participação ativa, troca de experiências e acompanhamento próximo.
            <br/>
            Os grupos são organizados por nível e objetivos semelhantes, mantendo o foco e a qualidade.
            <br/>
            Você aprende junto — mas continua sendo visto.
          </Information>
          <HouseLogo />
        </WhiteWrapper>
        <WhiteWrapper id="aula-criancas">
          <SubTitle>Aulas para Crianças</SubTitle>
          <Information>
            Aprendizado leve, natural e significativo.
            <br/>
            As aulas para crianças são construídas a partir de metodologias lúdicas e interativas, respeitando a idade e o estágio de desenvolvimento. Trabalhamos vocabulário, compreensão e comunicação por meio de jogos, histórias e situações do cotidiano.
            <br/>
            O objetivo é criar familiaridade com o idioma e uma relação positiva com o aprendizado desde cedo.
          </Information>
        </WhiteWrapper>
        <WhiteWrapper id="testes-proeficiencia">
          <SubTitle>Preparação para Testes de Proficiência</SubTitle>
          <Information>
            Preparação estratégica e direcionada para exames oficiais.
            <br/>
            Oferecemos acompanhamento específico para testes de proficiência em inglês e espanhol, com foco em estrutura de prova, gestão de tempo, prática orientada e desenvolvimento das habilidades exigidas.
            <br/>
            Você se prepara com método, segurança e clareza sobre o que será avaliado.
          </Information>
          <ManchaLaranja />
        </WhiteWrapper>
    </Container>
  )
}
